module.exports = __webpack_public_path__ + "img/placeholder.358e2f27.webp";